import { YandexTaskParent, YandexTrackerEntityWithKey, YLogUser } from '@/types/yandex';
import { parseDuration } from '@/utils/parseDuration';

import { ITaskInfo } from './client';
import { TaskInfoServer } from './server';

export const defaultEntity: YandexTaskParent = Object.freeze({
  self: '',
  id: '',
  key: '',
  display: '',
});

export class TaskInfoModel implements ITaskInfo {
  assignee: YLogUser;
  createdAt: string;
  createdBy: YLogUser;
  description: string;
  estimation: number;
  favorite: boolean;
  id: string;
  key: string;
  originalEstimation: number;
  parent: YandexTaskParent;
  previousStatus: YandexTrackerEntityWithKey;
  priority: YandexTrackerEntityWithKey;
  queue: YandexTrackerEntityWithKey;
  spent: number;
  status: YandexTrackerEntityWithKey;
  statusStartTime: string;
  statusType: YandexTrackerEntityWithKey;
  summary: string;
  type: YandexTrackerEntityWithKey;
  updatedAt: string;
  updatedBy: YLogUser;

  constructor(data: ITaskInfo) {
    this.assignee = data.assignee;
    this.createdAt = data.createdAt;
    this.createdBy = data.createdBy;
    this.description = data.description;
    this.estimation = data.estimation;
    this.favorite = data.favorite;
    this.id = data.id;
    this.key = data.key;
    this.originalEstimation = data.originalEstimation;
    this.parent = data.parent;
    this.previousStatus = data.previousStatus;
    this.priority = data.priority;
    this.queue = data.queue;
    this.spent = data.spent;
    this.status = data.status;
    this.statusStartTime = data.statusStartTime;
    this.statusType = data.statusType;
    this.summary = data.summary;
    this.type = data.type;
    this.updatedAt = data.updatedAt;
    this.updatedBy = data.updatedBy;
  }

  static fromJson(data: TaskInfoServer): TaskInfoModel {
    return new TaskInfoModel({
      id: data.id,
      key: data.key,
      summary: data.summary,
      description: data.description || '',
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      createdBy: data.createdBy,
      updatedBy: data.updatedBy,
      assignee: data.assignee || data.createdBy,
      status: data.status,
      previousStatus: data.previousStatus || defaultEntity,
      priority: data.priority,
      queue: data.queue,
      type: data.type,
      parent: data.parent || defaultEntity,
      favorite: data.favorite || false,
      estimation: parseDuration(data.estimation || ''),
      originalEstimation: parseDuration(data.originalEstimation || ''),
      spent: parseDuration(data.spent || ''),
      statusStartTime: data.statusStartTime || '',
      statusType: data.statusType || defaultEntity,
    });
  }
}
